module.exports = __webpack_public_path__ + "static/img/image_news_over_11.ae8a3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_11.png
// module id = ttcM
// module chunks = 10